<template>
  <!--  메인  -->
  <div id="main_area">
    <div class="global_popup_wrapper" style="position: fixed; top: 90px; left: 20px; z-index: 10000; pointer-events: none;">
      <div v-for="(item, index) in popupList" :key="item._id" style="pointer-events: auto; background:#fff; border:1px solid #ccc; margin-bottom:10px; box-shadow: 0 4px 6px rgba(0,0,0,0.3);">
        <a :href="item.linkUrl" target="_blank" v-if="item.MAIN_IMG">
          <img :src="item.MAIN_IMG" style="max-width: 400px; display:block;" />
        </a>
        <div style="padding: 10px; display:flex; justify-content:space-between; align-items:center; background:#f1f1f1; font-size:14px; position: relative;">
          <label style="cursor:pointer;"><input type="checkbox" v-model="item.dontShowToday"> 오늘 하루 열지 않기</label>
          <button @click="closePopup(item, item.dontShowToday)" style="border:none; background:none; cursor:pointer; font-weight:bold;">닫기 X</button>
        </div>
      </div>
    </div>
    <!-- <event-popup /> -->

    <vueper-slides :touchable="false" autoplay>
      <vueper-slide
        v-for="(slide, index) in slideList"
        :key="index"
        :content="slide.content"
        :title="slide.title"
        :image="slide.image"
      >

        <div slot="slideContent">
          <v-layout>
            <div>
              <div>{{ slide.content }}</div>
              <div>{{ slide.title }}</div>
            </div>
          </v-layout>
        </div>
      </vueper-slide>
    </vueper-slides>

    <!--  메인 콘텐츠-->
    <div class="main">
      <!--main_visual-->
      <div class="float_banner">
        <div v-for="(obj, index) in bannerList" :key="index" >
          <div v-if="!obj.bHide" class="test">
            <h3>{{ obj.title }}</h3>
            <span>{{ obj.startDt | date }} ~ {{ obj.endDt | date }}</span>
            <a :href="obj.contentUrl" class="shortcut_btn" target="_blank" >바로가기</a>
            <a @click="obj.bHide =  !obj.bHide"><img :src="require('./../../assets/img/sub/svg/close.svg')" alt/></a>
            <img  v-if="obj.type == 1" :src="require('./../../assets/img/technology.png')" class="banner_img" alt/>
            <img  v-else-if="obj.type == 2" :src="require('./../../assets/img/love.png')" class="banner_img" alt/>
          </div>
        </div>
        <!--
        <div>
          <h3>오륙도 장학생 선발</h3>
          <span>2023.08.01 ~ 2023.09.02</span>
          <a href="#" class="shortcut_btn">바로가기</a>
          <a href="#"><img :src="require('./../../assets/img/sub/svg/close.svg')" alt/></a>
          <img :src="require('./../../assets/img/love.png')" class="banner_img" alt/>
        </div>

        <div>
          <h3>이공계 장학생 선발</h3>
          <span>2023.08.01 ~ 2023.09.02</span>
          <a href="#" class="shortcut_btn">바로가기</a>
          <a href="#"><img :src="require('./../../assets/img/sub/svg/close.svg')" alt/></a>
          <img :src="require('./../../assets/img/technology.png')" class="banner_img" alt/>
        </div>
        -->
      </div>

      <div class="m_cont_wrap">
        <div class="main_contents">
          <ul>
            <li>
              <router-link to="/business/educationsupport">
                <img :src="require('./../../assets/img/main/scholarship.png')" alt />
                <div class="txt">
                  <p class="tit">장학생선발</p>
                  <p>자세히 보기</p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/business/planningbusiness">
                <img :src="require('./../../assets/img/main/promotion.png')" alt />
                <div class="txt">
                  <p class="tit">기획사업</p>
                  <p>자세히 보기 </p>
                </div>
              </router-link>
            </li>
            <li>
              <router-link to="/business/scholarshipselection">
                <img
                  :src="require('./../../assets/img/main/education.png')"
                  alt
                />
                <div class="txt">
                  <p class="tit">교육학술후원</p>
                  <p>자세히 보기 </p>
                </div>
              </router-link>
            </li>

            <li>
              <router-link to="/intro/establishment">
                <img
                  :src="require('./../../assets/img/main/foundation.png')"
                  alt
                />
                <div class="txt">
                  <p class="tit">송원문화재단소개</p>
                  <p>자세히 보기 </p>
                </div>
              </router-link>
            </li>

            <li>
              <router-link to="/intro/establishment">
                <div class="txt">
                  <p class="tit">송원문화재단소개</p>
                  <span>+</span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="newswrpa_m">
          <!--재단소식-->
            <div class="main_new">
                <ul>
                  <li class="tit">What’s new</li>
                  <li class="tit_m">재단소식<router-link to="/notice/newslist"><a>+</a></router-link></li>
                  <li v-for="(obj, index) in GET_NEWS" :key="index">
                    <div @click="btnBoardDetail(obj)">
                      <div class="txt">{{ obj.title }}</div>
                      <div class="day">{{ obj.createdAt | date }}</div>
                    </div>
                  </li>
                </ul>
              </div>
          <!--공지사항-->
            <div class="divider_m"></div>
              <div class="main_new main_notice">
                <ul>
                  <li class="tit">Notice</li>
                  <li class="tit_m">공지사항<router-link to="/notice/noticelist"><a>+</a></router-link></li>
                  <li v-for="(obj, index) in GET_NOTICE_LIST" :key="index">
                    <div @click="btnBoardDetail(obj)">
                      <div class="txt">{{ obj.title }}</div>
                      <div class="day">{{ obj.createdAt | date }}</div>
                    </div>
                  </li>
                </ul>
              </div>
        </div>
      </div>
      <!--모바일 배너-->
      <div class="banner_m">
        송원문화재단은 동국제강이 지역사회에 보답하고자<br>1996년 12월 설립되었습니다
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import eventBus from "../common/eventBus";
import pm from "../common/protocolManager";
import { bannerSelectType } from "../common/util";

export default {
  components: { VueperSlides, VueperSlide, },
  data: () => ({
    bannerList: [],
    popupList: [],
    message: "MainPage.vue",
    slideList: [
      {
        content:"함께해서 더 커지는 기쁨",
        title: "<h2 class='tit'>SONGWON<br><span>FOUNDATION</span></h2>",

        image: require("./../../assets/img/main/mainbg-N011.png")
      },
      {
        content:"함께해서 더 커지는 기쁨",
        title: "<h2 class='tit'>SONGWON<br><span>FOUNDATION</span></h2>",

        image: require("./../../assets/img/main/mainbg-N022.png")
      }
    ],

  }),
  methods: {
    ...mapMutations(["setEventNewsList"]),
    btnBoardDetail(obj) {
      this.$router.push(`/notice/detail?id=${obj._id}&type=${obj.type}`);
    },

    reqBannerList() {

      let curDate = new Date();

      let url = "bannerList";
      pm.get(url)
        .then(result => {
          console.log('bannerList = ok');

          testData1 = result;


          console.log(`bannerList.length = ${result.list.length} `);

          if (result.list.length) {
            let tempTypeList = bannerSelectType();


            // bannerPopup1Obj

            for (let i = 0; i < result.list.length; i++) {

              if (i > 5 || this.bannerList.length >= 3) {
                // 최근 5건만 검색함
                break;
              }

              let sDate = null;
              let eDate = null;
              sDate = new Date(result.list[i].startDt);
              eDate = new Date(result.list[i].endDt);
              eDate.setHours(23);
              eDate.setMinutes(59);

              if (curDate >= sDate && curDate <= eDate) {

                //
                console.log(`curDate = ${curDate.toString()}`);
                console.log(`sDate = ${sDate.toString()}`);
                console.log(`eDate = ${eDate.toString()}`);


                this.bannerList.push(result.list[i]);
              }

            }
          }

        })
        .catch(err => {
          console.log('bannerList = err');
        });

    },
    reqPopupList() {
      let curDate = new Date();
      let url = "popupList";
      pm.get(url)
        .then(result => {
          if (result.list && result.list.length > 0) {
            for (let i = 0; i < result.list.length; i++) {
              let item = result.list[i];
              let sDate = new Date(item.startDt);
              let eDate = new Date(item.endDt);
              eDate.setHours(23); eDate.setMinutes(59);

              if (curDate >= sDate && curDate <= eDate && item.bHide !== true) {
                // Determine image path
                if (item.files && item.files.popupImage && item.files.popupImage.length) {
                  item.MAIN_IMG = pm.NAS_URL + item.files.popupImage[0].filename;
                }
                
                // Set default for checkbox
                item.dontShowToday = false;

                // Check localStorage
                let hideUntil = localStorage.getItem(`popup_${item._id}_hide_until`);
                let todayStr = curDate.toISOString().split('T')[0];
                if (hideUntil !== todayStr) {
                  this.popupList.push(item);
                }
              }
            }
          }
        })
        .catch(err => {
          console.log('reqPopupList = err');
        });
    },
    closePopup(item, dontShowToday) {
      if (dontShowToday) {
        let curDate = new Date();
        let todayStr = curDate.toISOString().split('T')[0];
        localStorage.setItem(`popup_${item._id}_hide_until`, todayStr);
      }
      let idx = this.popupList.findIndex(x => x._id === item._id);
      if (idx !== -1) {
        this.popupList.splice(idx, 1);
      }
    }

  },

  beforeDestroy() {
    eventBus.$off("EVENT_CHANGE_LOCALE");
  },
  mounted() {
    this.reqBannerList();
    this.reqPopupList();
  },
  computed: {
    ...mapGetters([ "getNewsList", "getNoticeList"  ]),
    GET_NEWS() {
      let list = [];
      for (let i = 0; i < this.getNewsList.length; i++) {
        list.push(this.getNewsList[i]);
        if (i == 2) {
          break;
        }
      }
      return list;
    },
    GET_NOTICE_LIST() {
      let list = [];
      for (let i = 0; i < this.getNoticeList.length; i++) {
        list.push(this.getNoticeList[i]);
        if (i == 2) {
          break;
        }
      }
      return list;
    },
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  created() {
    console.log("created - " + this.message);

  }
};
</script>





// WEBPACK FOOTER //
// src/components/layout/MainPage.vue